import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function ReviewsTab({ reviews, reload }) {
  const act = async (id, action, body) => {
    try {
      if (action === "delete") await api.delete(`/admin/reviews/${id}`);
      else await api.patch(`/admin/reviews/${id}`, body);
      toast.success("Updated");
      reload();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  if (reviews.length === 0)
    return <p className="text-sm text-[#93b4d4] py-10 text-center" data-testid="reviews-empty">No reviews submitted yet.</p>;

  return (
    <div className="space-y-4" data-testid="reviews-tab">
      {reviews.map((r) => (
        <article key={r.id} className="p-5 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20" data-testid={`review-row-${r.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
            <p className="text-white font-semibold text-sm">{r.name}{r.area ? ` · ${r.area}` : ""}</p>
            <span className="text-[#1e9bff] text-sm">{"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}</span>
          </div>
          <p className="text-sm text-[#c8d9ea] mb-3">&ldquo;{r.text}&rdquo;</p>
          <div className="flex flex-wrap items-center gap-2">
            <span className={`px-2.5 py-1 rounded-full border text-[10px] font-mono-lbl uppercase ${
              r.status === "approved" ? "border-emerald-500/40 text-emerald-400" : r.status === "rejected" ? "border-red-500/40 text-red-400" : "border-amber-500/40 text-amber-400"
            }`}>{r.status}</span>
            {r.status !== "approved" && (
              <button onClick={() => act(r.id, "patch", { status: "approved" })} data-testid={`review-approve-${r.id}`}
                className="px-4 py-1.5 rounded-lg bg-emerald-500/15 border border-emerald-500/40 text-emerald-400 text-xs font-mono-lbl uppercase hover:bg-emerald-500/25 transition-colors">
                Approve
              </button>
            )}
            <button onClick={() => act(r.id, "delete")} data-testid={`review-delete-${r.id}`}
              className="px-4 py-1.5 rounded-lg bg-red-500/15 border border-red-500/40 text-red-400 text-xs font-mono-lbl uppercase hover:bg-red-500/25 transition-colors">
              Delete
            </button>
          </div>
        </article>
      ))}
    </div>
  );
}
